/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with CRUD operations of Task
 */
import React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import PredictionForm from './PredictionForm';
import { getById } from '../APICalls/FormCalls';

const AnalyticsDetails = (props) => {
  const [form, setForm] = useState({
    AnalysisTasks: [],
    PredictionTasks: []
  });
  const [isEditable, setIsEditable] = useState('');
  const [selectedTask, setSelectedTask] = useState('');
  //const {userProfile} = useSelector(state => state.LayoutReducer.loggedInProfile);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split('/rubus/RbsAnalytics/UseCaseDetails/');
    const Id = path && path[1] ? path[1] : null;
    getUseCaseById(Id);
  }, [location.pathname]);
  // const getUseCaseById = async (Id) => {
  //   if (Id && Id !== 'new') {
  //     const response = await getById(Id);
  //     if (response && response.AnalysisTasks && response.AnalysisTasks.length !== 0) {
  //       response.AnalysisTasks.forEach((item, i) => {
  //         _.cloneDeepWith(response, (value) => {
  //           return value && value.AnalysisTasks && value.AnalysisTasks[i] && value.AnalysisTasks[i]['Date']
  //             ? {
  //                 ...(value.AnalysisTasks),
  //                 ...(value.AnalysisTasks[i]['Date'] = [
  //                   moment.utc(value.AnalysisTasks[i]['Date'][0], 'YYYY-MM-DD HH:mm:ss'),
  //                   moment.utc(value.AnalysisTasks[i]['Date'][1], 'YYYY-MM-DD HH:mm:ss')
  //                 ])
  //               }
  //             : _.noop();
  //         });
  //       });
  //       setSelectedTask('Analysis Tasks');
  //     } else {
  //       setForm(response);
  //       setSelectedTask('Prediction Tasks');
  //       setIsEditable(Id);
  //     }
  //     if (response && response.PredictionTasks && response.PredictionTasks.length !== 0) {
  //       response.PredictionTasks.forEach((item, i) => {
  //         _.cloneDeepWith(response, (value) => {
  //           return value && value.PredictionTasks && value.PredictionTasks[i] && value.PredictionTasks[i]['Date']
  //             ? {
  //                 ...(value.PredictionTasks),
  //                 ...(value.PredictionTasks[i]['Date'] = [
  //                   moment.utc(value.PredictionTasks[i]['Date'][0], 'YYYY-MM-DD HH:mm:ss'),
  //                   moment.utc(value.PredictionTasks[i]['Date'][1], 'YYYY-MM-DD HH:mm:ss')
  //                 ])
  //               }
  //             : _.noop();
  //         });
  //       });
  //       setSelectedTask('Prediction Tasks');
  //     } else {
  //       setForm(response);
  //       setSelectedTask('Analysis Tasks');
  //       setIsEditable(Id);
  //     }
  //     setForm(response);
  //     setIsEditable(Id);
  //   }
  // };
  
  const getUseCaseById = async (Id) => {
    if (Id && Id !== 'new') {
      let response = await getById(Id);
      if (
        response &&
        response.AnalysisTasks &&
        response.AnalysisTasks !== undefined &&
        response.AnalysisTasks.length !== 0
      ) {
        response.AnalysisTasks.map((item, i) => {
          return _.cloneDeepWith(response, (value) => {
            return value &&
              value !== null &&
              value.AnalysisTasks &&
              value.AnalysisTasks[i] &&
              value.AnalysisTasks[i]['Date']
              ? {
                  ...(value && value.AnalysisTasks),
                  ...(value.AnalysisTasks[i]['Date'] = [
                    moment.utc(
                      value.AnalysisTasks[i]['Date'] && value.AnalysisTasks[i]['Date'][0],
                      'YYYY-MM-DD HH:mm:ss'
                    ),
                    moment.utc(
                      value.AnalysisTasks[i]['Date'] && value.AnalysisTasks[i]['Date'][1],
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  ])
                }
              : _.noop();
          });
        });
       
        setSelectedTask('Analysis Tasks');
      } else {
        setForm(response);
        setSelectedTask('Prediction Tasks');
        setIsEditable(props.match.params.Id);
      }
      if (
        response &&
        response.PredictionTasks &&
        response.PredictionTasks !== undefined &&
        response.PredictionTasks.length !== 0
      ) {
        response.PredictionTasks.map((item, i) => {
          return _.cloneDeepWith(response, (value) => {
            return value && value !== null && value.PredictionTasks && value.PredictionTasks
              ? {
                  ...(value && value.PredictionTasks && value.PredictionTasks),
                  ...(value.PredictionTasks[i]['Date'] = [
                    moment.utc(
                      value.PredictionTasks[i]['Date'] && value.PredictionTasks[i]['Date'][0],
                      'YYYY-MM-DD HH:mm:ss'
                    ),
                    moment.utc(
                      value.PredictionTasks[i]['Date'] && value.PredictionTasks[i]['Date'][1],
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  ])
                }
              : _.noop();
          });
        });
        setSelectedTask('Prediction Tasks');
      } else {
        setForm(response);
        setSelectedTask('Analysis Tasks');
        setIsEditable(props.match.params.Id);
      }
      setForm(response);
      setIsEditable(props.match.params.Id);
    }
  };


  const getAdhocDataSource = () => {
    setForm(form);
    navigate('/rubus/RbsAnalytics/UseCase');
  };
  return (
    <>
      <PredictionForm
        formObject={form}
        getAdhocDataSource={getAdhocDataSource}
        isEditable={isEditable}
        selectedTask={selectedTask}
      />
    </>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});
export default connect(mapStateToProps)(AnalyticsDetails);
